/**
 * @returns Money or an empty object if price is undefined.
 */

export const getPlanPriceV3 = plan => {
  var _plan$pricingVariants;
  const value = plan == null || (_plan$pricingVariants = plan.pricingVariants) == null || (_plan$pricingVariants = _plan$pricingVariants[0]) == null || (_plan$pricingVariants = _plan$pricingVariants.pricingStrategies) == null || (_plan$pricingVariants = _plan$pricingVariants[0]) == null || (_plan$pricingVariants = _plan$pricingVariants.flatRate) == null ? void 0 : _plan$pricingVariants.amount;
  return value && plan.currency ? {
    value,
    currency: plan.currency
  } : {};
};
//# sourceMappingURL=get-plan-price-v3.js.map